// Конфигурация для ONLYOFFICE Document Server
const DEBUG = process.env.NODE_ENV === 'development';
export const ONLYOFFICE_CONFIG = {
  // Поддерживаемые типы файлов
  supportedFileTypes: {
    'docx': 'word',
    'doc': 'word',
    'xlsx': 'cell',
    'xls': 'cell',
    'pptx': 'slide',
    'ppt': 'slide',
    'pdf': 'word',
    'txt': 'word',
    'rtf': 'word'
  },

  // Настройки редактора по умолчанию
  defaultEditorConfig: {
    mode: 'edit', // 'view' для просмотра, 'edit' для редактирования
    lang: 'ru',
    region: 'ru-RU',
    user: {
      id: '1',
      name: 'Пользователь'
    },
    customization: {
      autosave: false,
      forcesave: true,
      chat: false,
      comments: false,
      help: true,
      // hideRightMenu: false,
      // hideRulers: false,
      // hideToolbar: false,
      // hideZoom: false,
      // hideLeftMenu: false,
      compactHeader: true,
      // compactToolbar: false,
      // toolbarNoTabs: false
    }
  },

  // Разрешения для документов
  documentPermissions: {
    edit: true,
    download: true,
    print: true,
    review: true
  },

  // Настройки JWT (если true — ожидаем готовый подписанный token из опций getDocumentConfig)
  useJWT: true
};

// Функция для получения конфигурации документа
export const getDocumentConfig = (documentUrl, documentName, login, key, options = {}) => {
  const fileExtension = documentName.split('.').pop()?.toLowerCase();
  const documentType = ONLYOFFICE_CONFIG.supportedFileTypes[fileExtension] || 'word';

  const config = {
    document: {
      fileType: fileExtension,
      key: key + '',
      title: documentName,
      url: documentUrl,
      permissions: ONLYOFFICE_CONFIG.documentPermissions
    },
    documentType: documentType,
    editorConfig: {
      ...ONLYOFFICE_CONFIG.defaultEditorConfig,
      ...options.editorConfig
    },
    height: options.height || '100%',
    width: options.width || '100%'
  };

  // Убираем пустые значения из конфигурации
  Object.keys(config).forEach(key => {
    if (config[key] === undefined || config[key] === null) {
      delete config[key];
    }
  });

  DEBUG && console.log('✅ Финальная конфигурация ONLYOFFICE:', config);
  return config;
};
